import { StockCheckCategory, StockCheckItem, StockCheckLocation } from '../../../app/services/api/generated';
import { StockCheckStatus } from '../../../enums/StockCheckStatus';

export interface StockCheck {
    id?: number;
    name: string | undefined;
    storeNumber: string | undefined;
    status?: StockCheckStatus;
    plannedCountDate?: string;
    isSmartCount: boolean;
    createdBy: string | undefined;
    parentId: number | undefined;
    canMergeCount: boolean;
    lockTillCountDay: boolean;
    lockTillHour?: number;
    updateSmartCountItems?: boolean;
    approver: string | undefined;
    tolerancePercentage: number | undefined;
    toleranceValue: number | undefined;
    startDate: string | undefined;
    endDate: string | undefined;
    countedBy: string | undefined;
    approvedBy: string | undefined;
    approvedDate: string | undefined;
    documentDetailsId: number | undefined;
    canStartCount: boolean;
    unlockTimeUtc: string | undefined;
    items: StockCheckItem[] | undefined;
    categories: StockCheckCategory[] | undefined;
    productTypes: string[] | undefined;
    locations: StockCheckLocation[] | undefined;
    stockCheckType?: number | undefined;
}

export interface IStockCheckScheduleCategory {
  primaryCategoryId: number ;
  primaryCategoryName: string;
}

export interface IStockCheckItem {
  id: number;
  stockCheckId: number;
  itemNumber: string;
  description: string;
  category: string;
  productType: string;
  primaryUom: string;
  tolerancePercentage: number;
  toleranceValue: number;
  quantityOnHand: number;
  costPriceOnHand: number
}

export interface GetItemsByIdsRequest {
    storeNumber: string | undefined;
    itemNumbers: string[] | undefined;
    stockItemsOnly: boolean;
}

export const productTypes = ['FOOD', 'PAPER', 'EXPENSE', 'OTHER'];